import { Carousel } from "vue3-carousel";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("vCarroucel", Carousel);
});
